import module_31ba10c5477846fca72f4df4ca4e0dd3 from '../includes/glsl-compat.vert'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\n\n'+
(module_31ba10c5477846fca72f4df4ca4e0dd3())+
'\n\nprecision '+
(obj.highp)+
' float;\n\n\nIN vec2 aPosition;\nIN vec2 aTexCoord;\nuniform mat4 uMVP;\n\nOUT vec2 vTexCoord;\n\nvoid main(void){\n  vec4 pos = uMVP * vec4(aPosition, 0.0, 1.0);\n  gl_Position = pos;\n  vTexCoord = aTexCoord;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
